export const getRandomNum = () => {
	const random = Math.random() * 100_000_000_000_000
	return Number(random.toFixed(0))
}
